// @greenlight-spec: 19-design-system.md
import * as React from 'react';
import { Lock } from 'lucide-react';

import { MonoValue } from '@/components/greenlight/MonoValue';
import { cn } from '@/lib/utils';

export interface CopyRowProps {
  label: string;
  value: string;
  copyable?: boolean;
  locked?: boolean;
  lockedHint?: string;
  mono?: boolean;
  className?: string;
}

export function CopyRow({
  label,
  value,
  copyable = true,
  locked = false,
  lockedHint,
  mono = true,
  className,
}: CopyRowProps): React.ReactElement {
  return (
    <div className={cn('flex items-start justify-between gap-3 px-5 py-3.5', className)}>
      {/* Left: label + optional locked hint */}
      <div className="flex shrink-0 flex-col gap-0.5">
        <div className="flex items-center gap-1.5">
          {locked && (
            <Lock className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
          )}
          <span className="text-sm text-foreground">{label}</span>
        </div>
        {locked && lockedHint && (
          <span className="text-xs text-muted-foreground">{lockedHint}</span>
        )}
      </div>

      {/* Right: value */}
      <div className="flex min-w-0 flex-1 justify-end">
        {mono ? (
          <MonoValue copyable={copyable} wrap title={value}>
            {value}
          </MonoValue>
        ) : (
          <span
            className="break-all text-right font-mono text-[13px] text-foreground"
            title={value}
          >
            {value}
          </span>
        )}
      </div>
    </div>
  );
}
